/*
 * @Author: 刘枫
 * @Date: 2020-10-30 11:40:58
 * @Last Modified by: 李志远
 * @Last Modified time: 2022-11-Th 04:22:30
 */

<template>
  <div class="conInner">
    <section id="content_wrapper">
      <div class="data">
        <h2>我的收藏夹</h2>
      </div>
      <div class="tip">
        <div class="top"></div>
        <div class="body">
          <img src="//static.kxymall.com/images/gth.jpg">
          <div>
            <h2>温馨提示</h2>
            <p>1、这里将显示您的收藏夹信息。</p>
            <p>2、您还可以查看您收藏的所有信息、管理您的收藏夹等操作。</p>
          </div>
        </div>
        <div class="bottom"></div>
      </div>
      <div class="tab">
        <ul>
          <li v-bind:class="{'selected':tab==1}"><a v-on:click="changeTab(1)"><span>收藏的商品</span></a></li>
          <li v-bind:class="{'selected':tab==2}"><a v-on:click="changeTab(2)"><span>收藏的店铺</span></a></li>
        </ul>
      </div>
      <div class="box">
        <div class="top"></div>
        <div
          class="body"
          v-if="tab==1"
        >
          <div
            class="empty"
            v-if="!favoriteList.length"
          >暂无信息</div>
          <table
            cellspacing="0"
            cellpadding="3"
            class="liststyle"
            style="width: 100%"
            v-if="favoriteList.length"
          >
            <tbody>
              <tr>
                <th>&nbsp;&nbsp;</th>
                <th style="width: 20%">商品图片</th>
                <th style="width: 60%">商品信息</th>
                <th style="width: 20%">操作</th>
              </tr>
            </tbody>
            <tbody>
              <tr
                class="hovertr"
                v-for="row in favoriteList"
                :key="row.goodsId"
              >
                <td class="checkbox">&nbsp;&nbsp;</td>
                <td class="img">
                  <router-link
                    :to="{ path: '/goods', query: { goods_id: row.goodsId}}"
                    v-bind:title="row.goodsName"
                    class="img"
                  >
                    <img
                      :src="row.thumbnail"
                      height="55"
                      width="55"
                    >
                  </router-link>
                </td>
                <td class="param">
                  <dl>
                    <dt>
                      <router-link
                        :to="{ path: '/goods', query: { goods_id: row.goodsId}}"
                        v-bind:title="row.goodsName"
                      >
                        {{row.goodsName}}
                      </router-link>
                    </dt>
                    <dd>
                      <span>商品编号：{{row.goodsSn}}</span>
                    </dd>
                    <dd>
                      销售价：<strong>￥{{row.goodsPrice}}</strong>
                    </dd>
                  </dl>
                </td>
                <td
                  class="oper"
                  v-if="row.goodsDisabled == 0 && row.marketEnable == 1"
                >
                  <a
                    v-on:click="remove(row.goodsId)"
                    class="del_favorite"
                  >删除</a>
                </td>
                <td
                  class="oper"
                  v-if="row.goodsDisabled == 1 || row.marketEnable == 0"
                >
                  <a
                    v-on:click="remove(row.goodsId)"
                    class="del_favorite"
                  >删除</a>
                  <div class="product_status">失效</div>
                </td>
              </tr>
            </tbody>
          </table>
          <div
            class="pager_border"
            v-if="favoriteList.length"
          >
            <Page
              ref="pages"
              :total="dataTotal"
              show-total
              :page-size="pageSize"
              @on-change="changepage"
              size="small"
              show-elevator
            ></Page>
          </div>
        </div>
        <div
          class="body"
          v-if="tab==2"
        >
          <div
            class="empty"
            v-if="!collectStoreList.length"
          >暂无信息</div>
          <table
            cellspacing="0"
            cellpadding="3"
            class="liststyle"
            style="width: 100%"
            v-if="collectStoreList.length"
          >
            <tbody>
              <tr>
                <th>&nbsp;&nbsp;</th>
                <th style="width: 20%">店铺图片</th>
                <th style="width: 40%">店铺名称</th>
                <th style="width: 20%">收藏时间</th>
                <th style="width: 20%">操作</th>
              </tr>
            </tbody>
            <tbody>
              <tr
                class="hovertr"
                v-for="row in collectStoreList"
                :key="row.storeId"
              >
                <td class="checkbox">&nbsp;&nbsp;</td>
                <td class="img">
                  <router-link
                    :to="{ path: '/shop', query: { tab: 1,store_id:row.storeId}}"
                    v-bind:title="row.storeName"
                    class="img"
                  >
                    <img
                      :src="row.storeLogo"
                      height="55"
                      width="55"
                    >
                  </router-link>
                </td>
                <td class="param">
                  <dl>
                    <dt>
                      <router-link
                        :to="{path:'/shop',query:{tab: 1,store_id:row.storeId}}"
                        v-bind:title="row.storeName"
                      >
                        {{row.storeName}}
                      </router-link>
                    </dt>
                    <dd>
                      <span>{{row.storeProvince}}&nbsp;{{row.storeCity}}&nbsp;{{row.storeRegion}}</span>
                    </dd>
                  </dl>
                </td>
                <td>{{row.createTime}}</td>

                <td class="oper">
                  <a
                    v-on:click="remove(row.storeId)"
                    class="del_favorite"
                  >删除</a>
                </td>
              </tr>
            </tbody>
          </table>
          <div
            class="pager_border"
            v-if="collectStoreList.length"
          >
            <Page
              ref="pages"
              :total="dataTotal"
              show-total
              :page-size="pageSize"
              @on-change="changepage"
              size="small"
              show-elevator
            ></Page>
          </div>
        </div>
        <div class="bottom"></div>
      </div>
    </section>
  </div>
</template>
<script>
import {
  getFavoriteList,
  getCollectStoreList,
  collectStoreDelete,
} from "api/user.js";
import { favoriteDelete } from "@/api/goods";
export default {
  data() {
    return {
      tab: 1,
      dataTotal: 0,
      pageSize: 10,
      tabOldVal: "",
      favoriteList: [],
      collectStoreList: [],
    };
  },
  created() {
    if (this.$route.query.status == 1) {
      this.tab = 1;
      this.getFavoriteList(1);
    } else if (this.$route.query.status == 2) {
      this.tab = 2;
      this.getCollectStoreList(1);
    }
  },
  computed: {},
  watch: {
    // 如果路由有变化，会再次执行该方法
    $route: {
      handler: function () {
        this.setTabIndex();
      },
      deep: true,
    },
  },
  methods: {
    setTabIndex: function () {
      if (this.$route.path === "/member/favorite") {
        if (this.$route.query.status == "2") {
          this.tab = 2;
          this.getCollectStoreList(1);
        } else if (this.$route.query.status == "1") {
          this.tab = 1;
          this.getFavoriteList(1);
        }
      }
    },
    remove: function (id, index) {
      if (this.tab == 1) {
        this.$Modal.confirm({
          content: "<p>确定要删除此商品收藏吗？</p>",
          onOk: () => {
            let data = {
              goodsId: id,
              type: 1
            }
            favoriteDelete(data).then((json) => {
              if (json.resCode == "1") {
                this.$Message.success(json.resDesc);
                setTimeout(() => {
                  this.getFavoriteList(1);
                }, 500);
              } else {
                this.$Message.error(json.resDesc);
              }
            });
          },
        });
      } else if (this.tab == 2) {
        this.$Modal.confirm({
          content: "<p>确定要删除此店铺收藏吗？</p>",
          onOk: () => {
            let data = {
              storeId: id,
              type: 2
            }
            collectStoreDelete(data).then((json) => {
              if (json.resCode == "1") {
                this.$Message.success(json.resDesc);
                setTimeout(() => {
                  this.getCollectStoreList(1);
                }, 500);
              } else {
                this.$Message.error(json.resDesc);
              }
            });
          },
        });
      }
    },
    getDate: function (num) {
      var newDate = new Date();
      newDate.setTime(num * 1000);
      return newDate.toLocaleDateString();
    },
    changeTab: function (n) {
      this.tab = n;
      if (this.tabOldVal != n)
        this.$router.push({ query: { status: this.tab } });
      this.tabOldVal = n;
    },
    changepage(index) {
      this.$refs["pages"].currentPage = index;
      if (this.tab == 1) this.getFavoriteList(index);
      if (this.tab == 2) this.getCollectStoreList(index);
    },
    getFavoriteList: function (pageNo) {
      let _params = {
        pageNo: pageNo,
        pageSize: this.pageSize,
        type: 1,
      };
      getFavoriteList(_params).then((json) => {
        if (json.resCode == "1") {
          this.favoriteList = json.data.list;
          this.dataTotal = json.data.total;
        } else {
          this.$Message.error(json.resDesc);
        }
      });
    },
    getCollectStoreList: function (pageNo) {
      let _params = {
        pageNo: pageNo,
        pageSize: this.pageSize,
        type: 2,
      };
      getCollectStoreList(_params).then((json) => {
        if (json.resCode == "1") {
          this.collectStoreList = json.data.list;
          for (var i in this.collectStoreList) {
            this.collectStoreList[i].createTime = this.getDate(
              this.collectStoreList[i].createTime
            );
          }
          this.dataTotal = json.data.total;
        } else {
          this.$Message.error(json.resDesc);
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// favorite.vue?072716a6